import React from 'react';
import { Link } from 'react-router-dom';
import TableWrapper from '../../elements/TableWrapper';
import {
    Layout, message,  Row, Col, Switch
} from 'antd';
import MiCompAPI from '../../../util/api';
import img from '../../../assets/img/At the office-pana 1.png';
const { Content } = Layout;
class Brokers extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [{
            title: 'First Name',
            dataIndex: 'first_Name',
            render: (text, record) => {return <Link to={{ pathname: '/brokers/' + record["id"], state: { broker_id: record["id"] } }}>{text}</Link>},
            sorter: (a, b) => a.first_Name.localeCompare(b.first_Name),
            sortDirections: ["descend", "ascend"]
        }, {
            title: 'Middle Name',
            dataIndex: 'middle_Name',
            sorter: (a, b) => a.middle_Name.localeCompare(b.middle_Name),
            sortDirections: ["descend", "ascend"]
        }, {
            title: 'Last Name',
            dataIndex: 'last_Name',
            sorter: (a, b) => a.last_Name.localeCompare(b.last_Name),
            sortDirections: ["descend", "ascend"]
        }, {
            title: 'Email',
            dataIndex: 'email',
            sorter: (a, b) => a.email.localeCompare(b.email),
            sortDirections: ["descend", "ascend"]
        },
        {
            title: 'Type', 
            dataIndex: 'internal',
            render: (text,record) => {return record.internal?'Internal':'External'},  
            sorter: (a, b) => a.email.localeCompare(b.email),
            sortDirections: ["descend", "ascend"]
        },{
            title: 'Actions',
            dataIndex: 'client_id',
            render: (text,record) => <>


                <Switch defaultChecked={record["isActive"]} style={{ marginRight: '10px' }} onChange={this.ChangeStatusOfBroker.bind(this, record["user_Id"])} />

            </>
          }];

        this.state = {
            allBrokersLoading: true,
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    ChangeStatusOfBroker = (id) => {
        this.api.invoke("ChangeStatusOfUser/" + id, "patch", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                }
                else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.getBrokers();
            }
        });
    }

    componentDidMount() {
        this.getBrokers();
    }
    getBrokers() {
        this.api.invoke("BSU_GetAllBrokers", "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const brokers = data.data;
                    brokers.map(broker => {
                        broker.name = broker.broker_name;
                        broker.address = broker.street + " " + broker.city + " " + broker.state + " " + broker.zip;
                        return null;
                    });
                    this.data = brokers;
                    this.setState({ allBrokersLoading: false });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }
    render() {
        return (
            <Content>
                 <div className="mi_main_div" style={{paddingLeft:"10px",paddingRight:"10px"}}>
                    <div className="mi_box">
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">Brokers</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '182px', marginTop: '-80px' }} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <TableWrapper rowKey="id" columns={this.columns} data={this.state.allBrokersLoading ? null : this.data} loading={this.state.allBrokersLoading} title="All Brokers" search={true} />
                </div>
            </Content>
        );
    }
}
export default Brokers;